import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";
import useBorseRequestCompleteMutation from "../../hooks/mutations/useBorseRequestCompleteMutation";
import SubmitRequestModal from "../submit-request-modal";

const BorseSubmitRequestModal = ({ show, closeModal, request }) => {
  const { userProfile } = useContext(UserContext);
  const { labels, currentRequest, setCurrentRequest } = useContext(BorseContext);
  const queryClient = useQueryClient();

  const { mutateAsync: asyncSubmitRequest, isError } = useBorseRequestCompleteMutation(closeModal);

  const submitObject = {
    submitRequest: async (request) => {
      await asyncSubmitRequest({ request });
    },
    isError,
  };

  const saveDraft = () => {
    closeModal();
    setCurrentRequest();
    queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
  };

  return (
    <SubmitRequestModal
      show={!!show}
      closeModal={closeModal}
      labels={labels}
      saveDraft={saveDraft}
      submitObject={submitObject}
      request={request || currentRequest}
    />
  );
};

export default BorseSubmitRequestModal;
